import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cesionderechos',
  templateUrl: './cesionderechos.component.html',
  styles: []
})
export class CesionderechosComponent implements OnInit {
  constructor() { }

  ngOnInit() {

}


}
